window.$ = window.jQuery = require('jquery');
require('./jquery.maskMoney.min');
require('./jquery.mask');
require("flatpickr");
require('flatpickr/dist/l10n/pt');
require('./jquery.printPage');
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// window.axios = require('axios');
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

//Busca cep
$(document).on('blur','.cep',function() {
    var cep = $(this).val().replace(/\D/g, '');
    if (cep != "") {
        var validacep = /^[0-9]{8}$/;
        if(validacep.test(cep)) {
            //Preenche os campos com "..." enquanto consulta webservice.
            $(".rua").val("...");
            $(".bairro").val("...");
            $(".cidade").val("...");
            $(".uf").val("...");

            $.getJSON("//viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                    //Atualiza os campos com os valores da consulta.
                    $(".rua").val(dados.logradouro);
                    $(".bairro").val(dados.bairro);
                    $(".cidade").val(dados.localidade);
                    $("#city").val(dados.ibge);
                    $(".uf").val(dados.uf);
                } //end if.
                else {
                    $('.rua').focus();
                    alert("CEP não encontrado.");
                }
            });
        } //end if.
        else {
            $('.rua').focus();
            alert("Formato de CEP inválido.");
        }
    }
});

var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    options = {onKeyPress: function(val, e, field, options) {
            field.mask(maskBehavior.apply({}, arguments), options);
        }
    };

$('.tel').mask(maskBehavior, options);
$(".cep").mask("99999-999");
$(".cnpj").mask("99.999.999/9999-99");
$(".cpf").mask("999.999.999-99");
$('.hora').mask('99:99');
$('.data').mask('99/99/9999');
$('.dataModal').mask('99/99/9999');
$('.dataHora').mask('99/99/9999 99:99');
$('.monetary').maskMoney();
$('body').on('focus', '.money', function(){
    $(this).maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
});

$('body').on('focus', '.dataModal,.data', function(){
    $(this).mask('99/99/9999');
});

$('body').on('focus', '.controle', function(){
    $(this).mask('99.999.999.999.999');
});

$('body').on('focus', '.mesAno', function(){
    $(this).mask('99/9999');
});
var CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length <= 11 ? '000.000.000-009' : '00.000.000/0000-00';
    },
    cpfCnpjpOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(CpfCnpjMaskBehavior.apply({}, arguments), options);
        }
    };

$('.cpfcnpj').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);

$(".data").flatpickr({
    "locale": "pt",
    'allowInput' : true,
    'dateFormat': "d/m/Y",
});

$('.servs').each(function(){
    $('.ss'+$(this).data('pai')).remove();
});

$('body').on('click','.sendPermit',function(e){
    $element = $(this);
    $element.hide();
    var td = $element.parent();
    td.append('...');
    var value = $(this).data('value');
    var grupo = $(this).data('group');
    var action = $(this).data('action');
    var url = window.location.origin + '/permissions/liberar/'+action+'/'+grupo;
    if(value == 0){
        var info = '<a href="javascript:;" class="sendPermit text-red-600" data-group="'+grupo+'" data-action="'+action+'" data-value="1">' +
            '<svg width="30" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">' +
            '<path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />' +
            '</svg></a>';
    } else{
        var info = '<a href="javascript:;" class="sendPermit text-green-600" data-group="'+grupo+'" data-action="'+action+'" data-value="0">' +
            '<svg width="30" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">' +
            '<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />' +
            '</svg></a>';
    }
    $.ajax({
        type: "GET",
        url: url,
        async: true,
        cache: false,
        success: function (data, status) {
            $('.fa-spinner').remove();
            if (data == "erro") {
                $element.show();
                alert('Ocorreu um erro ao processar a requisição, tente novamente')
            } else {
                td.html(info);
            }
        }
    });
});
$(".printPage").printPage({
    message:"Seu documento está sendo impresso"
});

$(document).on('click','.printPage2',function(){
    $(this).printPage({
        message:"Seu documento está sendo impresso",
        attr:'data-href'
    });
    $(this).click();
});
$('.goWithForm').on('click', function(e){
    e.preventDefault();
    var link = $(this).attr('href');
    var form = $(this).closest('form').serialize();
    window.location = link+'?'+form;
});
$('.alert-toast').on('click', function () {
    $(this).remove();
});

$('.addContato').on('click', function () {
    var id = $(this).data('id');
    var table = $('#'+id);
    var tr = $('#'+id+' tbody tr:first').clone();
    var trFinal = $('#'+id+' tbody tr:last').clone();
    var original = parseInt(trFinal.find('.ordem').val());
    tr.find('.tel').mask(maskBehavior, options);
    tr.find('.data').mask('99/99/9999');
    tr.find('.data').flatpickr({
        "locale": "pt",
        'allowInput' : true,
        'dateFormat': "d/m/Y",
    });
    tr.find(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
    tr.find('.goReq').prop('required',true);
    tr.find('.ordem').val(isNaN(original) ? 1 : original+1);
    tr.appendTo(table).show('slow');
    tr.appendTo(table).show('slow');
});

$('.addEpi').on('click', function () {
    var id = $(this).data('id');
    var table = $('#'+id);
    var tr = $('#'+id+' tbody tr:first').clone();
    tr.find('.goReq').prop('required',true);
    tr.appendTo(table).show('slow');
    tr.appendTo(table).show('slow');
});

$('.addSindicato').on('click', function () {
    var id = $(this).data('id');
    var table = $('#'+id);
    var tr = $('#'+id+' tbody tr:first').clone();
    tr.appendTo(table).show('slow');
    tr.appendTo(table).show('slow');
});

$('.loadImg').on('click', function () {
    $("#myModal").show();
});

$('.closeModal').on('click', function () {
    $("#myModal").hide();
});

$("input").not($(":button")).keypress(function (evt) {
    if (evt.keyCode == 13) {
        iname = $(this).val();
        if (iname !== 'Submit') {
            var fields = $(this).parents('form:eq(0),body').find('button, input, textarea, select');
            var index = fields.index(this);
            if (index > -1 && (index + 1) < fields.length) {
                fields.eq(index + 1).focus();
            }
            return false;
        }
    }
});

